import numeral from 'numeral';

export default {
  methods: {
    formatAmount(value = 0) {
      return numeral(value).format('0,0.00');
    },
  },
};
